module.exports = __webpack_public_path__ + "static/img/loading.4408aa6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loading.png
// module id = SnTU
// module chunks = 18